import React from 'react';
import { MenuGroupProps } from '../__base';
import { CompanyPermissionConfig, CompanyUrl } from '@/routers/companyRouters';
import { DiscountIcon, HomeIcon, RoleIcon, SettingIcon, StaffIcon, SubscriptionIcon } from '@/assets/icons/entities/_';

const urls = CompanyUrl.Growing;

export const GrowingMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: urls.Dashboard,
        permissions: CompanyPermissionConfig.__getPermission(urls.Dashboard),
      },
    ],
  },
  {
    groupName: 'menu.SystemSettings',
    items: [
      {
        icon: <StaffIcon />,
        title: 'menu.Staffs',
        key: 'staffs',
        to: urls.Staffs,
        permissions: CompanyPermissionConfig.__getPermission(urls.Staffs),
      },
      {
        icon: <RoleIcon />,
        title: 'menu.Roles',
        key: 'roles',
        to: urls.Roles,
        permissions: CompanyPermissionConfig.__getPermission(urls.Roles),
      },
      {
        icon: <SettingIcon />,
        title: 'menu.CompanySettings',
        key: 'company-settings',
        to: urls.CompanySettings,
        permissions: CompanyPermissionConfig.__getPermission(urls.CompanySettings),
      },
      {
        icon: <SubscriptionIcon />,
        title: 'menu.Subscriptions',
        key: 'subscriptions',
        to: urls.Subscriptions,
        permissions: CompanyPermissionConfig.__getPermission(urls.Subscriptions),
      },
      {
        icon: <DiscountIcon />,
        title: 'menu.Discounts',
        key: 'discounts',
        to: urls.Discounts,
        permissions: CompanyPermissionConfig.__getPermission(urls.Discounts),
      },
    ],
  },
];
